(function () {
  'use strict';

  angular
    .module('app.cart.display', ['component.delete-cart-item', 'component.modify-cart-item'])

    .directive('cartDisplay', function () {
      return {
        restrict: 'A',
        bindToController: {
          device: '<',
          step: '<'
        },
        controllerAs: 'cartCtrl',
        /* @ngInject */
        controller: ["$scope", "$rootScope", "$location", "$timeout", "$element", "AppService", "CartService", "HttpService", "ModalService", "RoutesService", "toastr", function ($scope, $rootScope, $location, $timeout, $element, AppService, CartService, HttpService, ModalService, RoutesService, toastr) {
          var ctrl = this;
          ctrl.loadedCart = false;
          ctrl.NextEnabled = true;

          // Cart Aside
          ctrl.toggleUpdate = function (model) {
            CartService.toggleUpdate(ctrl, model);
          };
          ctrl.submitCode = function (event) {
            if (String(ctrl.formCode.data.code) === '') return;
            $(event.target).find('.form-control').blur();
            CartService.submitCode(ctrl);
          };
          ctrl.cancelCode = function (code) {
            CartService.cancelCode(ctrl, code);
          };
          ctrl.addLoyaltyPoint = function () {
            CartService.addLoyaltyPoint(ctrl);
          };
          ctrl.cancelLoyaltyPoint = function () {
            CartService.cancelLoyaltyPoint(ctrl);
          };
          ctrl.useCredit = function (id) {
            CartService.useCredit(ctrl, id);
          };
          ctrl.cancelCredit = function (id) {
            CartService.cancelCredit(ctrl, id);
          };
          ctrl.cancelGiftCard = function (code) {
            CartService.cancelGiftCard(ctrl, code);
          };
          // End Cart Aside

          var isGiftEnabled = false,
            cartTooltip = ctrl.NextTooltip;

          // Translate
          var tplTranslate = {};
          $element.children('.translate').children().each(function () {
            var $this = $(this);
            tplTranslate[$this.attr('key')] = $this.html();
          });

          if (typeof $location.search().cart !== 'undefined') {
            AppService.getParams()
              .then(function (data) {
                if (!data.HasCart) {
                  ctrl.restoreCart($location.search().cart);
                } else {
                  getCart();
                  ModalService.show(
                    '/Template/Cart/ModalRestoreCartConfirm',
                    {
                      cartCtrl: ctrl
                    },
                    null,
                    'restoreCartConfirmModalCtrl'
                  );
                }
              })
              .catch(function (error) {
                console.error(error);
              });
          } else {
            getCart();
          }

          ctrl.emptyCart = function () {
            ModalService.show(
              '/Template/Cart/ModalClearCartConfirm',
              {
                action: function () {
                  $rootScope.$broadcast('showPageLoader', true);
                  $timeout(function () {
                    $rootScope.$broadcast('showPageLoader', true);
                  }, 450);
                  window.location = $rootScope.backToStore || '/';
                }
              },
              null,
              'clearCartConfirmModalCtrl'
            );
          };

          ctrl.saveCartConnect = function (url) {
            AppService.getParams(true)
              .then(function () {
                ctrl.saveCart(url);
              });
          };

          ctrl.saveCart = function (redirect) {
            AppService.getParams()
              .then(function (params) {
                if (!params.IsLogged) {
                  ModalService.show(
                    '/Template/Authentication/ModalAuthentication',
                    {
                      message: tplTranslate.SaveCartMessage,
                      url: $location.path(),
                      action: function (redirectUrl) {
                        ctrl.saveCartConnect(redirectUrl);
                      }
                    },
                    null,
                    'loginModalCtrl'
                  );
                } else {
                  $scope.$emit('showPageLoader', true);
                  HttpService.post({
                    url: 'Cart/SaveCart',
                    data: {}
                  })
                  .then(function (response) {
                    AppService.getTranslate()
                      .then(function (translate) {
                        if (response.status === 'OK') {
                          toastr.success('', translate.messages.SaveCartOK, {
                            allowHtml: true,
                            extraData: {
                              template: 'toast_message.tpl'
                            }
                          });
                          if (!params.IsManagementWebCartTracking) {
                            $rootScope.$broadcast('userUpdate');
                          }
                        } else {
                          toastr.warning(translate.errors.TryLater, translate.errors.ErrorHasOccurred, {
                            allowHtml: true,
                            extraData: {
                              template: 'toast_message.tpl'
                            }
                          });
                        }
                        if (redirect) {
                          $location.path(redirect);
                        }
                        $scope.$emit('showPageLoader', false);
                      });
                  });
                }
              })
              .catch(function (error) {
                console.error(error);
              });
          };

          ctrl.openModify = function (event, item) {
            event.preventDefault();
            ModalService.show(
              '/Template/Cart/ModalModify',
              {
                item: item
              },
              'lg',
              'modalModifyCtrl',
              null,
              ctrl.device
            );
          };

          ctrl.restoreCart = function (hash) {
            $rootScope.$broadcast('showPageLoader', true);
            HttpService.post({
              url: '/Cart/RestoreCart',
              data: {
                Hash: hash
              }
            })
            .then(function (response) {
              if (response.status === 'OK') {
                $location.search({}).replace();
                AppService.updateParams(response.results);
              }
              $rootScope.$broadcast('showPageLoader', false);
            })
            .catch(function (error) {
              console.error(error);
            });
          };

          ctrl.alertAvailability = function (data) {
            ModalService.show(
              '/Template/Cart/ModalAlertAvailability',
              {
                DeleteQuantityLines: data
              }
            );
          };

          ctrl.setGiftMessage = function (value) {
            if (typeof value === 'undefined') {
              value = ctrl.cart.GiftComment !== '';
            }
            CartService.saveGift(value, ctrl.cart.GiftComment)
              .then(function (response) {
                if (response && response.status === 'OK') {
                  var message = value ? tplTranslate.CommentSaved : tplTranslate.CommentDeleted;
                  toastr.success('', message, {
                    allowHtml: true,
                    extraData: {
                      template: 'toast_message.tpl'
                    }
                  });
                }
              });
          };

          ctrl.addSuggestion = function (product) {
            $rootScope.$broadcast('showPageLoader', true);
            AppService.addToCart([
              {
                idProduct: product.IDProduct,
                quantity: 1
              }
            ])
            .then(function (response) {
              if (response.status === 'OK') {
                AppService.updateParams(response.results);
                toastr.success(product.Designation, tplTranslate.TitleModifyOk, {
                  allowHtml: true,
                  extraData: {
                    template: 'toast_addtocart.tpl',
                    data: {
                      img: product.IDPicture
                    }
                  }
                });
              }
              $rootScope.$broadcast('showPageLoader', false);
            });
          };

          ctrl.changeGiftAttribute = function (line) {
            line.showLoader = true;
            var id = line.Product.SelectedProduct ? line.Product.IDGroupingProduct : line.Product.IDProduct;
            var url = '_-p-' + id;
            _.each(line.attributes, function (attribute) {
              url = attribute.selected === '' ? url : url + '/' + attribute.selected;
            });
            CartService.getProduct(url)
              .then(function (product) {
                line.Product = product.SelectedProduct ? product.SelectedProduct : product;

                if (product.SelectedProduct) {
                  HttpService.post({
                    url: 'Product/SetElementary',
                    data: line.Product.IDProduct
                  }).then(function (response) {
                    return response;
                  })
                  .catch(function (error) {
                    throw error;
                  });
                }
                checkGiftProductsValid();
                line.showLoader = false;
              });
          };

          // Events

          $scope.$on('cartUpdate', function () {
            getCart();
          });

          $scope.$watch('cartCtrl.cart.IsGift', function (value) {
            if (value === undefined) return;
            if (!isGiftEnabled) {
              isGiftEnabled = true;
              return;
            }
            if (!value) ctrl.cart.GiftComment = '';
            ctrl.setGiftMessage(value);
          });

          // Functions

          function checkAvailability() {
            AppService.checkAvailability()
              .then(function (checkResponse) {
                if (checkResponse && checkResponse.status === 'OK') {
                  if (checkResponse.results.DeleteQuantityLines) {
                    var deleteQuantityLine = checkResponse.results.DeleteQuantityLines;
                    if (deleteQuantityLine.length) {
                      CartService.update(ctrl, checkResponse.results.VisitorContext);
                      ctrl.alertAvailability(deleteQuantityLine);
                    }
                  }
                }
              })
              .catch(function (error) {
                console.error(error);
              });
          }

          function setNextLink() {
            CartService.updateStepsCart(ctrl);

            var _routes = RoutesService.get();
            ctrl.nextStep = '/';
            var route = ctrl.isNumericCart ? _routes.CartPayment.url : _routes.CartShipping.url;
            route = ctrl.cart.RestToPay === 0 ? _routes.CartValidation.url : route;
            route = !ctrl.isLogged ? _routes.CartIdentification.url : route;
            ctrl.nextStep = '/' + route;
          }

          function getCart() {
            if (!ctrl.loadedCart && AppService.cartRequests.length) {
              ctrl.isUpdating = true;
              return;
            }
            ctrl.isUpdating = false;
            AppService.getParams()
              .then(function (data) {
                if (data.HasCart) {
                  CartService.update(ctrl, data, true);
                  getCustoms();
                  getCartSuggestions();
                  setNextLink();
                  checkGiftProducts();
                  checkAvailability();
                } else {
                  ctrl.cart = {
                    Products: []
                  };
                  ctrl.count = 0;

                  ctrl.isLogged = false;
                  ctrl.hasCart = false;

                  ctrl.nextStep = $rootScope.backToStore;

                }
                ctrl.loadedCart = true;
              })
              .catch(function (error) {
                console.error(error);
              });
          }

          function getCustoms() {
            _.each(ctrl.cart.Products, function (line) {
              if (line.Product.Customization) {
                _.each(line.Product.Customization.Items, function (item) {
                  if (!item.Group) {
                    if (item.Field.Value && item.Field.Code === 'DateEnvoi') {
                      item.Field.Value = item.Field.Value.split('T')[0];
                    }
                  }
                  if (item.Group) {
                    _.each(item.Group.Fields, function (field) {
                      if (field.Value && field.Code === 'DateEnvoi') {
                        field.Value = field.Value.split('T')[0];
                      }
                    });
                  }
                });
              }
            });
          }

          function getCartSuggestions() {
            ctrl.suggestions = [];
            HttpService.post({
              url: '/GetProductsOfTheme',
              data: {
                keyTheme: 'SuggestionsPanier'
              }
            })
            .then(function (response) {
              if (response.status === 'OK' && response.results.length) {
                _.each(_.filter(response.results, function (item) {
                  return item.AllowAddToCart || item.IsGroupingProduct;
                }), function (item) {
                  var available = true;
                  _.each(ctrl.cart.Products, function (line) {
                    if (line.Product.IDProduct === item.IDProduct || line.Product.IDGroupingProduct === item.IDProduct) {
                      available = false;
                    }
                  });
                  if (available) {
                    ctrl.suggestions.push(item);
                  }
                });
              }
            })
            .catch(function (error) {
              console.error(error);
            });
          }

          function checkGiftProducts() {
            _.each(ctrl.cart.ProduitOffert.Products, function (line) {
              line.attributes = [];
              _.each(line.Product.Attributes, function (att) {
                var current = {
                  selected: '',
                  options: [{
                    name: att.Designation,
                    value: ''
                  }]
                };
                _.each(att.Values, function (opt) {
                  if (opt.Selected) current.selected = opt.Value;
                  current.options.push({
                    name: opt.Value,
                    value: opt.Key
                  });
                });
                line.attributes.push(current);
              });
            });
            checkGiftProductsValid();

            setTimeout(refreshSelects);
          }

          function checkGiftProductsValid() {
            ctrl.NextTooltip = cartTooltip;
            ctrl.NextEnabled = true;

            _.each(ctrl.cart.ProduitOffert.Products, function (line) {
              if (_.filter(line.attributes, { selected: '' }).length) {
                ctrl.NextTooltip = tplTranslate.ChooseGiftMessage;
                ctrl.NextEnabled = false;
              }
            });
          }

          function refreshSelects() {
            setTimeout(function () {
              $element.find('select.refresh').each(function (index, el) {
                $(el).selectpicker('refresh');
              });
            });
          }

        }]
      };
    })

    /* @ngInject */
    .controller('shippingListModalCtrl', ["data", "device", "options", "ShippingService", function (data, device, options, ShippingService) {
      var ctrl = this;
      ctrl.device = device;

      ctrl.showLoader = true;
      ShippingService.getList()
        .then(function (response) {
          ctrl.showLoader = false;
          ctrl.shipping = response.results;

          _.each(ctrl.shipping.shippingList, function (item) {
            item.imgSrc = '/img/shipping/' + _.camelCase(item.Key) + '_small.png';
            if (item.Key === 'ENLEVEMENT' && item.TTCPrice === 0) {
              item.FinalPrice = 'gratis';
            } else if (item.TTCPrice === 0) {
              item.FinalPrice = 'free';
            }
          });
        })
        .catch(function (error) {
          console.error(error);
        });

    }])

    /* @ngInject */
    .controller('modalSendCartCtrl', ["HttpService", "AppService", "ModalService", "toastr", function (HttpService, AppService, ModalService, toastr) {
      var ctrl = this;
      ctrl.data = {};

      AppService.getParams()
        .then(function (data) {
          if (data.IsLogged) {
            ctrl.data.Email = data.Visitor.Email;
          }
        })
        .catch(function (error) {
          console.error(error);
        });

      ctrl.submit = function () {
        ctrl.loading = true;

        HttpService.post({
          url: 'Cart/SendByMail',
          data: ctrl.data
        })
        .then(function (response) {
          AppService.getTranslate()
            .then(function (translate) {
              if (response.status === 'OK') {
                ModalService.close();
                toastr.success('', translate.messages.SendCartOK, {
                  allowHtml: true,
                  extraData: {
                    template: 'toast_message.tpl'
                  }
                });
              } else {
                toastr.warning(translate.errors.TryLater, translate.errors.ErrorHasOccurred, {
                  allowHtml: true,
                  extraData: {
                    template: 'toast_message.tpl'
                  }
                });
              }
              ctrl.loading = false;
            });
        })
        .catch(function (error) {
          console.error(error);
        });
      };

    }])

    /* @ngInject */
    .controller('deleteConfirmModalCtrl', ["data", "device", "options", "ModalService", function (data, device, options, ModalService) {
      var ctrl = this;

      ctrl.submit = function () {
        ModalService.close();
        data.action();
      };
      ctrl.cancel = function () {
        ModalService.close();
        if (data.cancel) data.cancel();
      };

    }])

    /* @ngInject */
    .controller('modalModifyCtrl', ["data", "device", "options", "ModalService", "$scope", function (data, device, options, ModalService, $scope) {
      var ctrl = this;
      ctrl.data = data;
      ctrl.showLoader = true;

      $scope.device = device;

      ctrl.data.url = data.item.Product.URL;
      var str = data.item.Product.URL.split('-p-')[1];
      ctrl.updateFromCart = str.slice(str.indexOf('/'));
      ctrl.quantity = data.item.Quantity;
      ctrl.idLine = data.item.IDLine;

      ctrl.onLoad = function () {
        ctrl.showLoader = false;
      };

      ctrl.cancel = function () {
        ModalService.close();
      };

    }])

    /* @ngInject */
    .controller('clearCartConfirmModalCtrl', ["data", "$rootScope", "HttpService", "AppService", "ModalService", "toastr", function (data, $rootScope, HttpService, AppService, ModalService, toastr) {
      var ctrl = this;

      ctrl.submit = function () {
        ModalService.close();
        $rootScope.$broadcast('showPageLoader', true);
        HttpService.post({
          url: 'Cart/ClearCart',
          data: {}
        })
        .then(function (response) {
          AppService.getTranslate()
            .then(function (translate) {
              if (response.status === 'OK') {
                AppService.updateParams(response.results);
                toastr.success('', translate.messages.ClearCartOK, {
                  allowHtml: true,
                  extraData: {
                    template: 'toast_message.tpl'
                  }
                });
                if (data.action) data.action();
              } else {
                toastr.warning(translate.errors.TryLater, translate.errors.ErrorHasOccurred, {
                  allowHtml: true,
                  extraData: {
                    template: 'toast_message.tpl'
                  }
                });
              }
              $rootScope.$broadcast('showPageLoader', false);
            })
            .catch(function (error) {
              console.error(error);
            });
        })
        .catch(function (error) {
          console.error(error);
        });
      };

    }])

    /* @ngInject */
    .controller('restoreCartConfirmModalCtrl', ["data", "device", "options", "$location", "ModalService", function (data, device, options, $location, ModalService) {
      var ctrl = this;

      ctrl.submit = function (event) {
        event.preventDefault();
        ModalService.close();
        data.cartCtrl.restoreCart($location.search().cart);
      };

    }]);

})();
